@import 'apps/webcomponents/src/assets/fonts.scss';

* {
  box-sizing: border-box;
}

$iconSize: 24px;

:host {
  --panel-header-padding: 0 calc(2 * var(--spacer));
  --panel-header-font: var(--font-family-secondary);
  --panel-header-font-size: var(--body-size-large);
  --panel-content-padding: 0 calc(2 * var(--spacer)) 0 calc(4 * var(--spacer));
  --panel-content-font: var(--font-family-secondary);
  --panel-content-font-size: var(--body-size-large);
}

:host {
  display: block;
  max-width: 100%;
}

.panel {
  &--header {
    display: flex;
    justify-content: space-between;
    font-family: var(--panel-header-font);
    padding: var(--panel-header-padding);
    cursor: pointer;
    border: 1px solid transparent;
    color: var(--main-titles-inputs-600);
    .header-slot {
      max-width: calc(100% - $iconSize);
    }

    &:hover {
      background-color: var(--chart-050-hover);
    }
    &:focus-visible {
      outline: none;
      border-color: var(--blue-layout-500-focus);
    }
  }
  &--expander {
    font-family: var(--panel-content-font);
    padding: var(--panel-content-padding);
    // https://css-tricks.com/css-grid-can-do-auto-height-transitions/
    display: grid;
    grid-template-rows: 0fr;
    overflow: hidden;
    transition: grid-template-rows 0.3s ease-in-out;
  }
  &--content {
    min-height: 0;
    min-width: 0;
    transition: visibility 0.3s;
    visibility: hidden;
    color: var(--body-text-arrows-400);
  }
}

:host([isOpen]) {
  .panel {
    &--expander {
      grid-template-rows: 1fr;
    }
    &--content {
      visibility: visible;
    }
  }
}

:host([hideToggle]) {
  .panel {
    &--toggle-icon {
      display: none;
    }

    &--header {
      .header-slot {
        max-width: 100%;
        width: 100%;
      }
    }
  }
}
